<div class="login-page">
  <div class="login-card">
    <!-- Logo / Brand -->
    <div class="login-header">
      <img src="assets/logo.png" alt="BarClik" class="brand-logo">
      <p class="brand-tagline">Accede a tu cuenta</p>
    </div>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">

      <div class="field">
        <label for="email">Email</label>
        <div class="input-wrap" [class.error]="f['email'].invalid && f['email'].touched">
          <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          <input
            type="email"
            id="email"
            formControlName="email"
            placeholder="tu@email.com"
            autocomplete="email"
          >
        </div>
        <span class="field-error" *ngIf="f['email'].invalid && f['email'].touched">
          <span *ngIf="f['email'].errors?.['required']">Email es requerido</span>
          <span *ngIf="f['email'].errors?.['email']">Email no es valido</span>
        </span>
      </div>

      <div class="field">
        <label for="password">Contrasena</label>
        <div class="input-wrap" [class.error]="f['password'].invalid && f['password'].touched">
          <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <input
            type="password"
            id="password"
            formControlName="password"
            placeholder="Tu contrasena"
            autocomplete="current-password"
          >
        </div>
        <span class="field-error" *ngIf="f['password'].invalid && f['password'].touched">
          <span *ngIf="f['password'].errors?.['required']">Contrasena es requerida</span>
          <span *ngIf="f['password'].errors?.['minlength']">Minimo 6 caracteres</span>
        </span>
      </div>

      <!-- Remember + Forgot -->
      <div class="remember-forgot-row">
        <label class="remember-row">
          <input type="checkbox" formControlName="rememberSession">
          <span class="custom-check"></span>
          <span class="remember-text">Recordar sesion</span>
        </label>
        <button type="button" class="forgot-link" (click)="openForgotPassword()">
          He olvidado mi contrasena
        </button>
      </div>

      <!-- Global error -->
      <div class="alert-error" *ngIf="error">{{ error }}</div>

      <!-- Biometric login -->
      <button
        *ngIf="showBiometricOption && !loading"
        type="button"
        class="btn-biometric"
        (click)="loginWithBiometrics()"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
          <path d="M12 11c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"/>
          <path d="M18.4 4A10.93 10.93 0 0 0 12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.04-.56-3.94-1.53-5.57"/>
        </svg>
        Usar {{ biometricType }}
      </button>

      <div class="divider" *ngIf="showBiometricOption && !loading">
        <span>o</span>
      </div>

      <!-- Cloudflare Turnstile widget -->
      <div id="turnstile-login" class="turnstile-container"></div>

      <!-- Submit -->
      <button
        type="submit"
        class="btn-submit"
        [disabled]="loading || loginForm.invalid"
      >
        <span *ngIf="loading" class="spinner"></span>
        <span *ngIf="!loading">Iniciar Sesion</span>
        <span *ngIf="loading">Accediendo...</span>
      </button>

      <!-- OAuth -->
      <app-oauth-buttons></app-oauth-buttons>
    </form>

    <!-- Footer -->
    <div class="login-footer">
      <p>No tienes cuenta? <a routerLink="/register">Registrate</a></p>
    </div>
  </div>

  <!-- Forgot Password Modal -->
  <div class="modal-overlay" *ngIf="showForgotPassword" (click)="closeForgotPassword()"></div>
  <div class="forgot-modal" *ngIf="showForgotPassword">
    <div class="forgot-header">
      <h3>Recuperar contrasena</h3>
      <button type="button" class="close-btn" (click)="closeForgotPassword()">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="forgot-body">
      <p class="forgot-description" *ngIf="!forgotMessage">
        Introduce tu email y te enviaremos un enlace para restablecer tu contrasena.
      </p>

      <!-- Turnstile for forgot password -->
      <div id="turnstile-forgot" class="turnstile-container"></div>

      <div class="field" *ngIf="!forgotMessage">
        <label for="forgot-email">Email</label>
        <div class="input-wrap">
          <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          <input
            type="email"
            id="forgot-email"
            [(ngModel)]="forgotEmail"
            placeholder="tu@email.com"
            autocomplete="email"
            (keydown.enter)="submitForgotPassword()"
          >
        </div>
      </div>

      <div class="alert-error" *ngIf="forgotError">{{ forgotError }}</div>

      <div class="forgot-success" *ngIf="forgotMessage">
        <div class="success-icon-small">&#x2709;</div>
        <p>{{ forgotMessage }}</p>
        <p class="forgot-warning">Si no has sido tu quien lo ha solicitado, puedes ignorar este mensaje. Tu cuenta permanece segura.</p>
      </div>
    </div>

    <div class="forgot-footer">
      <button
        *ngIf="!forgotMessage"
        type="button"
        class="btn-submit"
        [disabled]="forgotLoading || !forgotEmail"
        (click)="submitForgotPassword()"
      >
        <span *ngIf="forgotLoading" class="spinner"></span>
        <span *ngIf="!forgotLoading">Enviar enlace</span>
        <span *ngIf="forgotLoading">Enviando...</span>
      </button>
      <button
        *ngIf="forgotMessage"
        type="button"
        class="btn-submit"
        (click)="closeForgotPassword()"
      >
        Volver al login
      </button>
    </div>
  </div>
</div>
